import request from "@/utils/request";

/**
 * 供应商入驻信息提交
 */
export const register = (data: any) =>
  request({
    url: "/seller/shops/supplier/register",
    method: "post",
    headers: { "Content-Type": "application/json" },
    data,
  });

/**
 * 商家入驻信息提交
 */
export const registerShop = (data: any) =>
  request({
    url: "/seller/shops/shop/register",
    method: "post",
    headers: { "Content-Type": "application/json" },
    data,
  });

/**
 * 获取供应商店铺入驻合同文件模板
 */
export const getSupplierContract = () =>
  request({
    url: "/seller/shops/get/supplierContract",
    method: "get",
  });

/**
 * 获取店铺入驻合同文件模板
 */
export const getShopContract = () =>
  request({
    url: "/seller/shops/get/contract",
    method: "get",
  });

/**
 * 分页查询供应商信息
 */
export function listSupplier(params: any) {
  return request({
    url: "/seller/shops/supplier/page",
    method: "get",
    params,
    needToken: true,
  });
}

/**
 * 分页查询商家信息
 */
export function getShopList(params: any) {
  return request({
    url: `/seller/shops/shop/page`,
    method: "get",
    params,
    needToken: true,
  });
}

/**
 * 查询供应商详情
 */
export function getSupplier(supplier_id: string) {
  return request({
    url: `/seller/shops/supplier/settle/${supplier_id}`,
    method: "get",
    needToken: true,
  });
}

/**
 * 供应商详情 by suppiler
 */
export function getSupplierDetail() {
  return request({
    url: `/seller/shops/supplier/get/supplier`,
    method: "get",
    needToken: true,
  });
}

/**
 * 查询商家详情
 */
export function getShopDetail(shop_id: string) {
  return request({
    url: `/seller/shops/shop/${shop_id}`,
    method: "get",
    needToken: true,
  });
}

/**
 * 商家详情 by shopname
 */
export function getShopDetailByShopName() {
  return request({
    url: `/seller/shops/shop/getShopInfo`,
    method: "get",
    needToken: true,
  });
}

/**
 * 供应商入驻审核
 */
export function auditSupplier(params: any) {
  return request({
    url: "/seller/shops/supplier/audit",
    method: "put",
    params,
    needToken: true,
  });
}

/**
 * 商家入驻审核
 */
export function auditShop(params: any) {
  return request({
    url: "/seller/shops/shop/audit",
    method: "put",
    params,
    needToken: true,
  });
}

/**
 * 企业端添加商家店铺入驻合同文件模板
 */
export function addShopContractTemplate(params: any) {
  return request({
    url: "/seller/shops/add/shopContract",
    method: "put",
    params,
    needToken: true,
  });
}

/**
 * 供应商店铺入驻合同文件模板
 */
export function getShopContractTemplate(params: any) {
  return request({
    url: "/seller/shops/add/supplierContract",
    method: "put",
    params,
    needToken: true,
  });
}

/**
 * 获取招商入住权限以及供应商权限
 */
export function getSellerPermission(enterprise_id) {
  return request({
    url: `/seller/shops/shop/getSettleAuth/${enterprise_id}`,
    method: "get",
    needToken: true,
  });
}
